import React, { useEffect, useState } from "react";
import FaqComponent from "../../component/places/page/FaqComponent";
import ArticleComponent from "../../component/article/ArticleComponent";
import ReviewComponent from "../../component/reviews/ReviewComponent";
import { useSelector } from "react-redux";
import VideosComponent from "../../component/videos/VideosComponent";
import ReviewSource from "../../component/reviews/ReviewSource";
import services from "../../services/services";
import { toast } from "react-toastify";
import { ReviewSourceType } from "../../component/reviews/type";

const tabs = [
  { id: 1, label: "FAQ's", icon: (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
  )},
  { id: 2, label: "Article", icon: (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" /></svg>
  )},
  { id: 3, label: "Reviews", icon: (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg>
  )},
  { id: 4, label: "Review Source", icon: (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" /></svg>
  )},
  { id: 5, label: "Video", icon: (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>
  )},
];

const Pages = () => {
  const [openTab, setOpenTab] = React.useState(1);
  const [reviewSources, setReviewSources] = useState<ReviewSourceType[]>([]);

  const fetchAllReviews = async () => {
    try {
      const response = await services.getAllReviewSources();
      let transformSource = response?.data?.map((item:any)=>{return {...item,["name"]: item?.sourcesName}})
      setReviewSources(transformSource);
    } catch (error) {
      toast.error("Unable to fetch review source");
      console.error("Error fetching review sources:", error);
    }
  };

  useEffect(() => {
    fetchAllReviews();
  }, []);

  const { adminPermission } = useSelector((state: any) => state.counter);

  if (adminPermission?.is_admin == 2 && !adminPermission?.pages) {
    return (
      <div className="flex items-center justify-center h-[80vh]">
        <div className="bg-white rounded-2xl shadow-lg px-10 py-8 text-center">
          <svg className="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
          <h1 className="text-2xl font-semibold text-gray-700 font-openSans">
            You don't have permission
          </h1>
          <p className="text-gray-400 mt-2 text-sm">Contact your administrator for access.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="px-6 md:px-12 py-8">
      {/* Page Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-[#1a1a2e] font-openSans">Pages</h1>
        <p className="text-sm text-[#6B7280] mt-1">Manage FAQs, articles, reviews, and videos</p>
      </div>

      {/* Content Card */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100">
        {/* Tabs */}
        <div className="border-b border-gray-200 px-6">
          <nav className="flex gap-1 overflow-x-auto" role="tablist">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setOpenTab(tab.id)}
                className={`
                  flex items-center gap-2 px-4 py-3.5 text-sm font-semibold uppercase tracking-wide
                  border-b-2 transition-all duration-200 font-openSans whitespace-nowrap
                  ${openTab === tab.id
                    ? "border-[#6ECDC5] text-[#6ECDC5]"
                    : "border-transparent text-[#6B7280] hover:text-[#1a1a2e] hover:border-gray-300"
                  }
                `}
                role="tab"
              >
                {tab.icon}
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="p-6">
          <div className={openTab === 1 ? "block" : "hidden"} id="link1">
            <FaqComponent />
          </div>
          <div className={openTab === 2 ? "block" : "hidden"} id="link2">
            <ArticleComponent />
          </div>
          <div className={openTab === 3 ? "block" : "hidden"} id="link3">
            <ReviewComponent sourceData={reviewSources} />
          </div>
          <div className={openTab === 4 ? "block" : "hidden"} id="link4">
            <ReviewSource sourceData={reviewSources} refreshData={fetchAllReviews} />
          </div>
          <div className={openTab === 5 ? "block" : "hidden"} id="link5">
            <VideosComponent />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pages;
